import { Popover } from "bootstrap";
import * as bootstrap from "bootstrap";

const closeAllModals = window.closeAllModals = () => {
  document.querySelectorAll('.modal').forEach((modal) => {
    bootstrap.Modal.getInstance(modal)?.hide()
  })
  const wrapper = document.getElementById('generalModal')
  if (wrapper) wrapper.innerHTML = ''
  document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove())

  document.body.classList.remove('modal-open')
  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('padding-right')
}

window.displayFlashMessage = (type, message) => {
  const existing = document.getElementById('flash')
  if (existing) existing.remove()

  // Map the flash type to the design-system toast type + icon (matches the
  // server-side flash_toast_style helper). Color carries the meaning.
  const toast = {
    success: { t: 'success', icon: 'circle-check' },
    notice:  { t: 'success', icon: 'circle-check' },
    warning: { t: 'warning', icon: 'triangle-alert' },
    info:    { t: 'info',    icon: 'info' },
  }[type] || { t: 'error', icon: 'circle-x' }

  const icons = {
    'circle-check': '<circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/>',
    'circle-x': '<circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/>',
    'triangle-alert': '<path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/>',
    info: '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>',
  }
  const iconSvg = `<svg class="lucide-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${icons[toast.icon]}</svg>`
  const closeSvg = `<svg class="lucide-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>`

  const flashHtml =
    `<div class="flash-message-wrapper sg-toast-wrap" id="flash" data-controller="flash-message">` +
      `<div class="sg-toast toast-plain flash flash-${toast.t}" role="status" aria-live="polite">` +
        `<span class="toast-icon ti-${toast.t}">${iconSvg}</span>` +
        `<div class="toast-body"><p class="toast-sentence">${message}</p></div>` +
        `<button type="button" class="toast-close" aria-label="Close" data-action="click->flash-message#dismiss">${closeSvg}</button>` +
      `</div>` +
    `</div>`

  document.body.insertAdjacentHTML('beforeend', flashHtml)
}

window.initSelect2 = (selector, parent = null, options = {}) => {
  $(selector).not('.select2-hidden-accessible').select2({
    allowClear: true,
    dropdownParent: parent,
    ...options,
    sorter: data => data.sort((a, b) => {
      if (!isNaN(parseInt(a.text))) {
        return parseFloat(a.text) > parseFloat(b.text)
      }
      return a.text.localeCompare(b.text)
    }),
  })
}

const init = () => {
  const noSearchOptions = {minimumResultsForSearch: Infinity};
  // Target only the <select> elements — NOT a bare `.select2`. Once select2
  // renders, it injects a `<span class="select2 select2-container …">`, which
  // ALSO carries `.select2`; a plain `$('.select2')` re-matches that container
  // on the next turbo:load (the `.not('.select2-hidden-accessible')` guard only
  // protects the <select>, not the container) and stacks a second, empty,
  // broken picker. Scoping to `select.select2` is the robust source fix — a
  // <span> container can never match it, so the double-init can't recur. This
  // removes the need for the per-controller double-init defenses.
  $('select.select2').each(function () {
    const parent = this.closest('.select2-search-off')
    window.initSelect2(this, parent || null, parent ? noSearchOptions : {});
  });

  window.enableTooltip()
}

window.enableTooltip = () => {
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })
}

document.addEventListener('turbo:load', () => {
  document.querySelectorAll('[data-popover-content-id]').forEach(el => {
    const contentId = el.getAttribute('data-popover-content-id');
    const content = document.getElementById(contentId);
    if (content) {
      new Popover(el, {
        html: true,
        content: content.innerHTML,
        trigger: 'focus', // or 'click'
        placement: 'top'
      });
    }
  });
});

window.init = init
$(document).on('turbo:load', init)
$(document).on('turbo:before-cache', () => {
  $('.select2-hidden-accessible').select2('destroy')
})